const ToggleButton = ({
  isActive,
  onChange,
  disabled = false,
  leftText = '',
  rightText = '',
  rightTextClassName,
  leftTextClassName,
}: {
  isActive: boolean
  onChange: (checked: boolean) => void
  leftText?: string
  rightText?: string
  rightTextClassName?: string
  leftTextClassName?: string
  disabled?: boolean
}) => {
  return (
    <div className='form-check form-switch form-check-custom form-check-solid me-2'>
      {leftText && <span className={`${leftTextClassName} px-2 py-1 fs-7 fw-bold rounded-2`}>{leftText}</span>
      }      <input
        className='form-check-input mx-2 h-20px w-40px'
        style={{ backgroundColor: '#808080' }}
        type='checkbox'
        value=''
        id='flexsSwitchDefault'
        checked={isActive}
        disabled={disabled}
        defaultChecked={true}
        onChange={(e) => onChange(e.target.checked)}
      />
      <label className='form-check-label ms-0' htmlFor='flexSwitchDefault'>
        {rightText && (
          <span className={`${rightTextClassName} fs-7 fw-bold rounded-2 px-2 py-1`}>
            {rightText}
          </span>
        )}
      </label>
    </div>
  )
}
export default ToggleButton
